import React, { FC, ReactNode, useState } from 'react';
import { Collapse } from '@mui/material';

import { ArrowDown24, ArrowUp24, IconButton, Stack, Typography, useMediaSwitch, useMobile } from 'Modules/ui3';


interface CollapsedContainerProps {
    title: ReactNode;
    text: ReactNode;
}
export const CollapsedContainer: FC<CollapsedContainerProps> = ({ text, title }) => {
    const [isOpen, setIsOpen] = useState(false);
    const Icon = isOpen ? ArrowUp24 : ArrowDown24;
    const isMobile = useMobile();

    const handleToggleClick = () => setIsOpen(prev => !prev);

    return (
        <Stack
            p={isMobile ? 4 : 8}
            bgcolor='#F5F5F5'
            borderRadius={isMobile ? 6 : 12}
        >
            <Stack
                direction='row'
                spacing={2}
                alignItems='center'
                justifyContent='space-between'
                onClick={handleToggleClick}
            >
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('24px', '20px', '16px')}
                    fontWeight={700}
                    lineHeight={isMobile ? '24px' : '32px'}
                    color='#242424'
                >
                    {title}
                </Typography>
                <IconButton
                    variant='secondary'
                    size={useMediaSwitch('extraExtraLarge', 'extraLarge', 'small')}
                    sx={{
                        borderRadius: useMediaSwitch(6, 5, 3),
                        ':hover': {
                            bgcolor: '#E6E6E6',
                        },
                        ':focus, :active': {
                            bgcolor: '#DBDBDB',
                        },
                    }}
                >
                    <Icon sx={{ fontSize: isMobile ? '16px' : '24px' }} />
                </IconButton>
            </Stack>
            <Collapse in={isOpen}>
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('20px', '16px', '14px')}
                    fontWeight={500}
                    lineHeight={useMediaSwitch('32px', '24px', '20px')}
                    color='#969592'
                    mt={2}
                    sx={{
                        '>a': {
                            color: '#FF3200',
                        },
                    }}
                >
                    {text}
                </Typography>
            </Collapse>
        </Stack>
    );
};
